import {
  NotifyGovWellSalesTeamAboutAdditionalUseCaseMutation,
  NotifyGovWellSalesTeamAboutAdditionalUseCaseMutationVariables,
  NotifyGovWellSalesTeamAboutAIAssistantMutation,
  NotifyGovWellSalesTeamAboutAIAssistantMutationVariables,
  NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutation,
  NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutationVariables,
  NotifyMarketingTeamAboutModuleInterestMutation,
  NotifyMarketingTeamAboutModuleInterestMutationVariables,
} from 'types/graphql'

import { useMutation } from 'src/utils/queryClient'

const NotifyGovWellSalesTeamAboutAIAssistant = gql`
  mutation NotifyGovWellSalesTeamAboutAIAssistantMutation($organizationId: Int) {
    notifyGovWellSalesTeamAboutAIAssistant(organizationId: $organizationId)
  }
`

export const useNotifyGovWellSalesTeamAboutAIAssistant = () => {
  return useMutation<
    NotifyGovWellSalesTeamAboutAIAssistantMutation,
    NotifyGovWellSalesTeamAboutAIAssistantMutationVariables
  >({
    mutationDocument: NotifyGovWellSalesTeamAboutAIAssistant,
  })
}

const NotifyGovWellSalesTeamAboutAdditionalUseCase = gql`
  mutation NotifyGovWellSalesTeamAboutAdditionalUseCaseMutation(
    $useCase: String!
    $additionalInformation: String!
    $organizationId: Int
  ) {
    notifyGovWellSalesTeamAboutAdditionalUseCase(
      useCase: $useCase
      additionalInformation: $additionalInformation
      organizationId: $organizationId
    )
  }
`

export const useNotifyGovWellSalesTeamAboutAdditionalUseCase = () => {
  return useMutation<
    NotifyGovWellSalesTeamAboutAdditionalUseCaseMutation,
    NotifyGovWellSalesTeamAboutAdditionalUseCaseMutationVariables
  >({
    mutationDocument: NotifyGovWellSalesTeamAboutAdditionalUseCase,
  })
}

const NotifyGovWellSalesTeamAboutHigherAIAssistantTier = gql`
  mutation NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutation(
    $tier: String!
    $organizationId: Int
  ) {
    notifyGovWellSalesTeamAboutHigherAIAssistantTier(tier: $tier, organizationId: $organizationId)
  }
`

export const useNotifyGovWellSalesTeamAboutHigherAIAssistantTier = () => {
  return useMutation<
    NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutation,
    NotifyGovWellSalesTeamAboutHigherAIAssistantTierMutationVariables
  >({
    mutationDocument: NotifyGovWellSalesTeamAboutHigherAIAssistantTier,
  })
}

const NotifyMarketingTeamAboutModuleInterest = gql`
  mutation NotifyMarketingTeamAboutModuleInterestMutation($moduleType: String!) {
    notifyMarketingTeamAboutModuleInterest(moduleType: $moduleType)
  }
`

export const useNotifyMarketingTeamAboutModuleInterest = () => {
  return useMutation<
    NotifyMarketingTeamAboutModuleInterestMutation,
    NotifyMarketingTeamAboutModuleInterestMutationVariables
  >({
    mutationDocument: NotifyMarketingTeamAboutModuleInterest,
  })
}
